import { getMultiStepQuizV4Template } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";
import { serializeDynamicComponents, visualizeDynamicComponents } from "@/assets/utilities/tinymce/visualization";

function serializeContent(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => serializeContent(item));
  } else {
    const newObj = {};
    Object.keys(obj).forEach(key => {
      if (key === "content") {
        const content = parseToHtml(obj[key]);
        serializeDynamicComponents(content);
        newObj[key] = content.body.innerHTML;
      } else if (key === "text") {
        const content = parseToHtml(obj[key]);
        serializeDynamicComponents(content);
        newObj[key] = content.body.innerHTML;
      } else {
        newObj[key] = serializeContent(obj[key]);
      }
    });

    return newObj;
  }
}

function visualizeContent(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => visualizeContent(item));
  } else {
    const newObj = {};
    Object.keys(obj).forEach(key => {
      if (key === "content") {
        const content = parseToHtml(obj[key]);
        visualizeDynamicComponents(content);
        newObj[key] = content.body.innerHTML;
      } else if (key === "text") {
        const content = parseToHtml(obj[key]);
        visualizeDynamicComponents(content);
        newObj[key] = content.body.innerHTML;
      } else {
        newObj[key] = visualizeContent(obj[key]);
      }
    });

    return newObj;
  }
}

/**
 *  When user clicks on a shortcode to edit it
 */
const editMultiStepQuizV4Config = (editor, shortcodeWrapper) => {
  let currentData = null;

  const multiStepQuizV4Window = editor.windowManager.openUrl({
    title: "Multi-Step Quiz #4",
    url: "/multi-step-quiz-v4-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      editor.windowManager.alert("Success!");
      shortcodeWrapper.setAttribute("data-multi-step-quiz-data", currentData);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "requestData") {
        sendData();
      }

      if (message.mceAction === "updateMultiStepQuizV4Data") {
        currentData = message.data;
      }
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });

  const sendData = () => {
    const multiStepQuizV4Data = shortcodeWrapper.getAttribute("data-multi-step-quiz-data");

    multiStepQuizV4Window.sendMessage({
      type: "sendData",
      data: multiStepQuizV4Data,
    });
  };
};

/**
 * when user adds shortcode initially
 */
const multiStepQuizV4Config = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Multi-Step Quiz #4",
    url: "/multi-step-quiz-v4-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getMultiStepQuizV4Template(),
        "multi-step-quiz-v4-shortcode",
      );
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute("data-multi-step-quiz-data", currentData);

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

export { multiStepQuizV4Config, editMultiStepQuizV4Config };
